module.exports = __webpack_public_path__ + "img/stock-1.db36e582.jpg";